module.exports = __webpack_public_path__ + "static/media/icon-chicken-green.43954205.jpg";